
import { format } from 'date-fns'

export function timeStampNow(): string {
    const now: Date = new Date()
    const text = format(now, 'yyyy_MM_dd_HH_mm_ss')
    return text
}

export function numberArrayToString(numberArray: Array<number>): string {
    let U8A = new Uint8Array(numberArray);
    U8A[U8A.length - 1] = 0 // Note: have zero-termination for sure
    const i_zero = U8A.indexOf(0)
    U8A = U8A.slice(0, i_zero)
    const S = new TextDecoder('utf-8').decode(U8A);
    return S
}